export default {
  brand: 'CryptoPay',
  transferHint: 'অনুগ্রহ করে নিচের ঠিকানায় ট্রান্সফার করুন',
  rechargeAmount: 'রিচার্জ পরিমাণ',
  rechargeAddress: 'রিচার্জ ঠিকানা',
  scanTip: 'আপনার ওয়ালেট দিয়ে QR কোড স্ক্যান করে পেমেন্ট করুন',
  copy: 'কপি',
  copied: 'কপি হয়েছে',
  copyFail: 'কপি ব্যর্থ হয়েছে',
  networkFee: 'নেটওয়ার্ক ফি',
  eta: 'আনুমানিক সময়',
  etaVal: '৫-১৫ মিনিট',
  actualArrival: 'আপনি পাবেন',
  noticeTitle: 'গুরুত্বপূর্ণ নির্দেশনা',
  notice1: 'অনুগ্রহ করে শুধুমাত্র এই পৃষ্ঠায় প্রদর্শিত QR কোড বা ঠিকানায় ট্রান্সফার করুন। ভুল ঠিকানায় পাঠানো সম্পদ পুনরুদ্ধার করা সম্ভব নয়।',
  notice2: 'ট্রান্সফার পরিমাণ অবশ্যই {amount} {coin} হতে হবে। পরিমাণ ভিন্ন হলে স্বয়ংক্রিয়ভাবে জমা হবে না।',
  notice3: 'ব্লকচেইন কনফার্মেশনের জন্য অপেক্ষা করুন (সাধারণত ১টি কনফার্মেশনের পর জমা হয়)।',
  notice4: 'অন-চেইন ট্রান্সফার বাতিল করা যায় না। ব্যবহারকারীর ভুলের কারণে হওয়া ক্ষতির দায় ব্যবহারকারীর।',
  selectLang: 'ভাষা নির্বাচন করুন',
  back: 'ফিরে',
  pending: 'অপেক্ষমাণ',
  paid: 'পরিশোধিত',
  timeout: 'মেয়াদ শেষ',
  orderNo: 'অর্ডার নম্বর',
  loading: 'লোড হচ্ছে…',
  paramError: 'লিংক প্যারামিটার অসম্পূর্ণ',
  initFail: 'অর্ডার তৈরি ব্যর্থ হয়েছে',
  paidSuccess: 'পেমেন্ট সফল',
  timedOut: 'অর্ডারের সময় শেষ হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন'
}